import { createStore } from "@stencil/store";
import { InfoBannerData, ReviewAverage, ReviewProduct } from "./common";
import { ProductCardData } from "./listing";

export const product = createStore({} as ProductData);

export interface ProductData {
    id: string;
    name: string,
    link: string;
    
    breadcrumbs: CategoryData[];
    categories: CategoryData[];

    brand: BrandData;
    brandName: string;
    description?: string;

    message?: string;

    attributes?: AttributeData[];

    currency?: string;
    previousPrice?: number;
    currentPrice: number;
    lowestPrice?: number;
    shippingPrice?: number;
    shippingTime: string;
    shippingMessage: string;

    availability: number;

    count: number,
    cartLoading?: boolean,
    favouritesLoading?: boolean,
    favouritesCompleted?: boolean,

    images?: ProductImageData[]
    traitIDs?: string;
    traits?: TraitData[]

    catalog?: string;
    model?: string;
    ean?: string;

    reviews ?: ReviewCollectionData;

    infoBanner ?: InfoBannerData;
    productBanner ?: ProductBannerData;

    history: string;

    energy: "A+++"|"A++"|"A+"|"A"|"B"|"C"|"D"|"E"|"F"|"G";
    energyLabel: string;
    energyOld: boolean;

    warranty: string;
    warrantyLink: string;

    recycle: TooltipAttribute;
    points: PointData;
    negotiateEnabled: boolean;
    installments: InstallmentData;

    tags: LinkPair[];
    variants: VariantData[];

    gspr?: TabDataGSPR;
    tabs: TabData[];
    youtube: string[];

    comments: CommentData;

    similar: ProductCardData[];
    accessories: ProductCardData[];

    reviewAverage: ReviewAverage;
    reviewProducts: ReviewProduct[];

    strings: ProductStringData;
}

export interface ProductStringData {
    model: string;
    ean: string;
    similarHeading: string;
    accessoriesHeading: string;
    notifyAvailability: string;
    unavailable: string;
    shippingIn: string;
    shippingFrom: string;
    freeShipping: string;
    lowestPrice: string;

    noInternet: string;

    notifyMe: string;
    notifyHeading: string;
    notifyParagraph: string;     
    notifyBackorders: string;
    notifyAgreement: string;
    notifySuccessHeading: string;
    notifySuccessParagraph: string;
    notifyErrorHeading: string;
    notifyErrorParagraph: string;
    
    negotiateAgreement: string;
    negotiateHeading: string;
    negotiateParagraph: string;
    negotiateSuccessHeading: string;
    negotiateSuccessMessage: string;
    negotiateFaliureHeading: string;
    negotiateFaliureMessage: string;
    negotiateComment: string;
    negotiateName: string;
    negotiateEmail: string;
    negotiateLink: string;
    negotiateSubmit: string;

    reviewsCount: string;
    reviewsAverage: string;
    reviewsPositive: string;
    reviewsNeutral: string;
    reviewsNegative: string;
}

export interface ProductShortData {
    id: string;
    traitIDs: string;
    sku: string;
    name: string;
    link: string;
    image: string;
    imageFull: string;
    currentPrice: number;
    quantity: number;
    currency: string;
    categories: CategoryNameData[];
    breadcrumbs: CategoryNameData[];
    brandName: string;
}

export interface ProductShortOrderData extends ProductShortData {
    shippingTime: string;
    warranty: string;
}


export interface ProductBannerData {
    image: string;
    webp: string;
    width: number;
    height: number;
    color: string;
    name: string;
    link: string;
}


export interface CommentData {
    addLink: string;
    addMessage: string;
    hideAfter: number;
    entries: Comment[];
}

export interface Comment {
    author: string;
    when: string;
    content: string;
}

export interface TabData {
    name: string;
    content?: string;
    gspr?: TabDataGSPR;
}

export interface TabDataGSPR {
    name?: string,
    info?: string,

    manufacturer?: TabDataGSPRInfo;
    responsible?: TabDataGSPRInfo;

    files: {
        url: string,
        name: string
    }[]
}

export interface TabDataGSPRInfo {
    name: string,
    country: string,			
    street: string,			
    postal_code: string,
    city: string,
    email: string,
    website: string,
    phone: string		
}

export interface VariantData {
    link: string;
    name: string;
    image: string;
    webp: string;
    active?: boolean;
    unavailable?: boolean;
}

export interface LinkPair {
    link: string;
    name: string;
}

export interface BrandData {
    name: string;
    link: string;
    logo: string;
    width: number;
    height: number;
}

export interface InstallmentData {
    button: string;
    attributeMessage: string;

    payuId: string;
    payuKey: string;
    payuIcon: string;

    caParameters: string;
    caIcon: string;
}

export interface TooltipAttribute {
    message: string;
    shortMessage: string;
}
export interface PointData {
    message: string;
    shortMessage: string;
    value: number;
    conversion: number;
    count: number;
}

export interface ReviewCollectionData {
    score: string
    count: string

    review: ReviewData[]
}

export interface AttributeData {
    name?: string;
    text?: string;
    link?: string;
    image?: string;
    emphasis?: boolean;
}

export interface ReviewData {
    name: string;
    text: string;
    overallScore: string;
    bestScore: string;
}

export interface CategoryData {
    id: string;
    name: string;
    link: string;
}

export interface CategoryNameData {
    id: string;
    name: string;
}

export interface ProductImageData {
    thumb: ProductImageProperties
    preview: ProductImageProperties
    full: ProductImageProperties
}

export interface ProductImageProperties {
    url: string
    webp?: string
    width?: number
    height?: number
}

export interface TraitData {
    name: string
    id: string
    items: TraitDataItem[]
}

export interface TraitDataItem {
    name: string
    id: string
}

export interface FetchedTraitData {
    kupowanie: string
    dostepnosc: string
    czaswysylki: string
    nrkat: string
    ean: string
    ilosc: string
    cena: string
    cenapoprzednia: string
}

export interface FetchedTraitImageData {
    male: string
    srednie: string
    duze: string
}